import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EMPTY, interval, Observable, Subscription } from 'rxjs';
import { concatMap, switchMap, take, tap } from 'rxjs/operators';
import { AUTH_RECOVERY_TIME } from '../../../../app.constants';
import { AuthFirebaseService } from '../../../services/auth-firebase.service';


@Component({
    templateUrl: './inactive-user-modal.component.html',
    styleUrls: ['./inactive-user-modal.component.scss'],
})
export class InactiveUserModalComponent implements OnInit, OnDestroy {
    currentLabels: any;

    private stayLogged = {
        title: 'core.inactive-user-modal.inactive.title',
        text: 'core.inactive-user-modal.inactive.text',
        confirmButtonTitle: 'core.inactive-user-modal.inactive.stay-logged',
    };
    private afterLogout = {
        title: 'core.inactive-user-modal.after-logout.title',
        text: 'core.inactive-user-modal.after-logout.text',
        confirmButtonTitle: 'system.ok',
    };
    private timerSubscription: Subscription;

    seconds: string;
    timer: Observable<number>;

    constructor(
        private dialogRef: MatDialogRef<InactiveUserModalComponent>,
        private authFirebaseService: AuthFirebaseService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: { forceLogoutMessage: boolean }
    ) {
        dialogRef.disableClose = true;
    }

    ngOnInit(): void {
        if (this.data && this.data.forceLogoutMessage) {
            this.currentLabels = this.afterLogout;
            this.logout().subscribe();
        } else {
            this.seconds = AUTH_RECOVERY_TIME.toString();
            this.currentLabels = this.stayLogged;

            this.timerSubscription = interval(1000)
                .pipe(
                    take(AUTH_RECOVERY_TIME),
                    concatMap((seconds) => {
                        this.seconds = (AUTH_RECOVERY_TIME - seconds)
                            .toString()
                            .padStart(2, '0');
                        // the event ends exactly on the 29th
                        if (seconds + 1 === AUTH_RECOVERY_TIME) {
                            this.currentLabels = this.afterLogout;
                            return this.logout();
                        }
                        return EMPTY;
                    })
                )
                .subscribe();
        }
    }

    private logout() {
        return this.authFirebaseService
            .signOut()
            .pipe(switchMap(() => this.router.navigate(['/auth'])));
    }

    ngOnDestroy(): void {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }

    action() {
        this.dialogRef.close(this.timerSubscription.closed);
    }
}
